<script>
export default {
  name: 'IntelligenceV2SuggestionChips',
  props: {
    // Mesmo payload do getter `promptSuggestions`: `[{ text, icon }]`. O
    // `icon` é ignorado de propósito — a pílula do protótipo é só texto.
    sugestoes: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  computed: {
    // Índice na chave: duas sugestões podem vir com o mesmo texto e `:key`
    // duplicado gera warning do Vue. A lista é curta e não reordena.
    itens() {
      return this.sugestoes.map(function (sugestao, indice) {
        const texto = sugestao && sugestao.text ? sugestao.text : sugestao
        return { chave: texto + '-' + indice, texto: texto }
      })
    },
    temItens() {
      return this.itens.length > 0
    },
  },
  methods: {
    usar(texto) {
      this.$emit('use', texto)
    },
  },
}
</script>

<template>
  <div v-if="temItens" class="suggestion-chips">
    <button
      v-for="item in itens"
      :key="item.chave"
      type="button"
      class="suggestion-chips__pilula ia-texto-corpo"
      @click="usar(item.texto)"
    >
      {{ item.texto }}
    </button>
  </div>
</template>

<style lang="sass" scoped>
// As pílulas fluem lado a lado e quebram para a linha seguinte quando não
// cabem, todas encostadas na borda esquerda — junto com o título e o composer.
// `align-items: flex-start` faz cada uma ter a largura do próprio texto; sem
// ele elas esticariam para a altura da linha.
// Numa coluna estreita (o painel do Hub tem ~420px) o wrap volta a dar uma
// pílula por linha sozinho, que era o desenho anterior — por isso a regra vale
// para as cinco superfícies do estado vazio, sem prop.
.suggestion-chips
  display: flex
  flex-wrap: wrap
  align-items: flex-start
  gap: 8px

.suggestion-chips__pilula
  color: var(--neutral-900)
  // <button> e não <div>: a sugestão é acionável, e o foco por teclado tem de
  // vir de graça em vez de tabindex + handler de Enter na mão.
  padding: 7px 14px
  // Cinza QUENTE e SEM borda, como no protótipo — medido lá: #EEECE9, a um
  // passo do nosso --ia-recessed-bg (#EFEDE9). O --neutral-100 anterior é um
  // cinza frio e destoava da família da tela. A borda saiu porque este tom
  // separa 1.081 do fundo sozinho, a mesma razão que faz o card branco ser
  // visível — contorno em cima disso era desenho a mais.
  border: 0
  border-radius: 999px
  background: var(--ia-recessed-bg)
  cursor: pointer
  transition: background 0.15s, border-color 0.15s

  &:hover
    background: var(--sidebar-warm-hover)
</style>
